import type {ReactElement} from 'react';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {Modal} from '@Components/modal';
import {LazyPanel} from '@Components/lazy-panel';

export default function ResubscribeConfirmationModal(): ReactElement {
  const modalId = MODALS_IDS.RESUBSCRIBE_CONFIRMATION_MODAL;
  const panelId = `${modalId}-panel`;

  return (
    <Modal modalId={modalId} panelId={panelId} modalHeight="auto" modalWidth="590px">
      <LazyPanel panelDirectoryName="resubscribe-confirmation-panel" panelProps={{panelId}} />
    </Modal>
  );
}

export const openResubscribeConfirmationModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.RESUBSCRIBE_CONFIRMATION_MODAL,
      panelProps: {},
    })
  );
};
